//@flow
//Action Type Registered
export const REFRESH_GORGON_FORMS_SUCCESS='REFRESH_GORGON_FORMS_SUCCESS'
export const REFRESH_GORGON_FORMS_ERROR='REFRESH_GORGON_FORMS_ERROR'
export const UPDATE_SELECTED_GORGON_FORM_NUM='UPDATE_SELECTED_GORGON_FORM_NUM'
export const CLEAR_SELECTED_GORGON_FORM_NUM='CLEAR_SELECTED_GORGON_FORM_NUM'
export const REFRESH_GORGON_FORM_QUESTIONS_SUCCESS='REFRESH_GORGON_FORM_QUESTIONS_SUCCESS'
export const REFRESH_GORGON_FORM_QUESTIONS_ERROR='REFRESH_GORGON_FORM_QUESTIONS_ERROR'
export const GORGON_DOC_SUBMIT_SUCCESS='GORGON_DOC_SUBMIT_SUCCESS'
export const GORGON_DOC_SUBMIT_ERROR='GORGON_DOC_SUBMIT_ERROR'
export const GORGON_DOC_SUBMITTED_COMPLETED='GORGON_DOC_SUBMITTED_COMPLETED'
export const GORGON_FORM_PANEL_EXPANDABLE_ADD='GORGON_FORM_PANEL_EXPANDABLE_ADD'
export const GORGON_FORM_PANEL_EXPANDABLE_REMOVE='GORGON_FORM_PANEL_EXPANDABLE_REMOVE'
export const GORGON_PANEL_PDF_CONTENT='GORGON_PANEL_PDF_CONTENT'
export const GORGON_PANEL_EMP_MEM_INFO='GORGON_PANEL_EMP_MEM_INFO'
export const GORGON_PANEL_APPLICANT_INFO='GORGON_PANEL_APPLICANT_INFO'
export const GORGON_PANEL_APPLICATION_INFO='GORGON_PANEL_APPLICATION_INFO'
export const GORGON_PANEL_PHYSICIAN_INFO='GORGON_PANEL_PHYSICIAN_INFO'
export const GORGON_PANEL_FORM_QUESTIONS='GORGON_PANEL_FORM_QUESTIONS'
export const GORGON_PANEL_ADDITIONAL_QUESTIONS='GORGON_PANEL_ADDITIONAL_QUESTIONS'
export const GORGON_PANEL_REVIEW_QUESTIONS='GORGON_PANEL_REVIEW_QUESTIONS'
export const UPDATE_GORGON_FORM_ERROR='UPDATE_GORGON_FORM_ERROR'
export const ADD_GORGON_FORM_APP_COVERAGE_LINE='ADD_GORGON_FORM_APP_COVERAGE_LINE'
export const REMOVE_GORGON_FORM_APP_COVERAGE_LINE='REMOVE_GORGON_FORM_APP_COVERAGE_LINE'
export const GET_GORGON_TASK_RESULTSET='GET_GORGON_TASK_RESULTSET'
export const EDIT_VERIFY_FORM_DATA_SUCCESS='EDIT_VERIFY_FORM_DATA_SUCCESS'
export const EDIT_VERIFY_FORM_DATA_ERROR='EDIT_VERIFY_FORM_DATA_ERROR'


// WEBPACK FOOTER //
// ./src/redux/gorgon/actionTypes.js